import BaseService from './BaseService';
import * as apiroutes from '../apiRoutes';

class MenuItemService extends BaseService {
    constructor() {
        super(apiroutes.MENU_ITEM);
    }

    async create(data) {
        // If data is FormData (contains file), use multipart
        const contentType = data instanceof FormData ? 'multipart' : 'json';
        return await super.customCall('POST', '', data, null, contentType);
    }

    async update(id, data) {
        // If data is FormData (contains file), use multipart
        const contentType = data instanceof FormData ? 'multipart' : 'json';
        return await super.customCall('PATCH', `/${id}`, data, null, contentType);
    }

    async updateStatus(id, data) {
        return await super.customCall('PUT', `/status/${id}`, data, null, 'json');
    }

    async delete(id) {
        return await super.delete(id);
    }

    async getAll(params = {}) {
        return await super.customCall('GET', '', null, params, null);
    }

    async getById(id) {
        return await super.getById(id);
    }

    async search(searchTerm, filters = {}) {
        return await super.search(searchTerm, filters);
    }
}

const MenuItemServices = new MenuItemService();

export default MenuItemServices;